export default "__VITE_ASSET__ueKCJykl__"